const REVIEW_URL_PATTERN = /https?:\/\/\S+|www\.\S+/gi

/** True if review text contains a URL (audit: no links to other sites). */
export function containsReviewUrl(text: string): boolean {
  REVIEW_URL_PATTERN.lastIndex = 0
  return REVIEW_URL_PATTERN.test(text || '')
}

/** Remove URL-like tokens from review text for safe display. */
export function stripReviewUrls(text: string): string {
  return (text || '')
    .replace(REVIEW_URL_PATTERN, '')
    .replace(/\s+/g, ' ')
    .trim()
}
